import { render, staticRenderFns } from "./carpetasVistaIconos.vue?vue&type=template&id=2d4c72bc&scoped=true"
import script from "./carpetasVistaIconos.vue?vue&type=script&lang=js"
export * from "./carpetasVistaIconos.vue?vue&type=script&lang=js"
import style0 from "./carpetasVistaIconos.vue?vue&type=style&index=0&id=2d4c72bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c72bc",
  null
  
)

export default component.exports